import Slider from '../helpers/Slider';
import SliderWithThumbs from '../helpers/SliderWithThumbs';
import { SELECTORS } from '../config/constants';

export default function () {
  initDefaultSliders();
  initSlidersWithThumbs();
}

function initDefaultSliders() {
  initSliders({ selector: SELECTORS.SLIDERS.DEFAULT, Service: Slider });
}

function initSlidersWithThumbs() {
  initSliders({ selector: SELECTORS.SLIDERS.WITH_THUMBS, Service: SliderWithThumbs });
}

function initSliders({ selector, Service }) {
  const sliderElems = document.querySelectorAll(selector);

  if (!sliderElems.length) {
    return;
  }

  sliderElems.forEach((el) => new Service(el).init());
}
